export default __webpack_public_path__ + "static/media/badge.bbb77b0c.svg";